'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPool = function MdPool(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm23.4 9.1c0-2.2 1.8-4.1 4.1-4.1s4.1 1.9 4.1 4.1-1.8 4.3-4.1 4.3-4.1-2-4.1-4.3z m-8.9 10.9c-1 0-1.4-0.2-2-0.6-0.3-0.3-0.7-0.4-1.2-0.6l5.3-5.4-1.6-1.8c-1.9-1.8-3.6-2.5-6.6-2.5v-4.1c4.1 0 6.5 0.8 9.1 3.4l10.7 10.6c-0.2 0.1-0.5 0.3-0.7 0.4-0.6 0.4-1 0.6-2 0.6s-1.2-0.2-1.8-0.6c-0.8-0.5-1.8-1-3.7-1s-2.9 0.5-3.7 1c-0.6 0.4-0.9 0.6-1.8 0.6z m22.1 7.5c-1.8 0-2.8-0.6-3.6-1.1-0.6-0.4-1-0.5-1.9-0.5s-1.3 0.1-1.9 0.5c-0.8 0.5-1.8 1.1-3.7 1.1s-2.8-0.6-3.5-1.1c-0.7-0.4-1.1-0.5-2-0.5s-1.2 0.1-1.9 0.5c-0.8 0.5-1.8 1.1-3.6 1.1s-2.9-0.6-3.6-1.1c-0.7-0.4-1.1-0.5-2-0.5s-1.2 0.1-1.9 0.5c-0.8 0.5-1.8 1.1-3.6 1.1v-3.4c0.9 0 1.2-0.1 1.8-0.5 0.8-0.5 1.8-1.1 3.7-1.1s2.8 0.6 3.6 1.1c0.6 0.4 1 0.5 2 0.5s1.2-0.1 1.8-0.5c0.8-0.5 1.8-1.1 3.7-1.1s2.8 0.6 3.6 1.1c0.6 0.4 1 0.5 1.9 0.5s1.3-0.1 1.9-0.5c0.8-0.5 1.8-1.1 3.7-1.1s2.8 0.6 3.6 1.1c0.6 0.4 1 0.5 1.9 0.5v3.4z m0 7.5c-1.8 0-2.8-0.6-3.6-1.1-0.6-0.4-1-0.5-1.9-0.5s-1.3 0.1-1.9 0.5c-0.8 0.5-1.8 1.1-3.7 1.1s-2.8-0.6-3.5-1.1c-0.7-0.4-1.1-0.5-2-0.5s-1.2 0.1-1.9 0.5c-0.8 0.5-1.8 1.1-3.6 1.1s-2.9-0.6-3.7-1.1c-0.6-0.4-1-0.5-1.9-0.5s-1.3 0.1-1.9 0.5c-0.8 0.5-1.8 1.1-3.6 1.1v-3.4c0.9 0 1.2-0.1 1.8-0.5 0.8-0.5 1.8-1.1 3.7-1.1s2.8 0.6 3.6 1.1c0.6 0.4 1 0.5 2 0.5s1.2-0.1 1.8-0.5c0.8-0.5 1.8-1.1 3.7-1.1s2.9 0.6 3.7 1.1c0.6 0.4 0.9 0.5 1.8 0.5s1.4-0.1 2-0.5c0.8-0.5 1.7-1.1 3.6-1.1s2.9 0.6 3.7 1.1c0.6 0.4 0.9 0.5 1.8 0.5v3.4z' })
        )
    );
};

exports.default = MdPool;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/pool.js
// module id = 1083
// module chunks = 0